import React from 'react'
import VideoLoop from '../VideoLoop'
import styled from 'styled-components'
const FramedVidLoop = styled.div`
    padding: 6rem 0;
    &.gray-bkg {
        background-color: #f4f4f4;
    }
    .framed-image-grid {
        display: grid;
        column-gap: 1rem;
        grid-template-columns: [spacer] 2fr [image] 8fr [spacer] 2fr;
    }
    .framed-image {
        grid-area: image;
    }
    video {
        width: 100%;
    }
`
const FramedVideoLoop = ({src, description, backgroundColor}) => {
    const bkg = backgroundColor === 'gray' ? true : false;
    return (
        <FramedVidLoop className={bkg ? 'gray-bkg row-component' : 'row-component'}>
             <div className="contain">
                <div className="framed-image-grid">
                    <div className="framed-image">
                        <VideoLoop src={src} description={description} />
                    </div>
                </div>
            </div>
        </FramedVidLoop>
    )
}

export default FramedVideoLoop
